import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

import { take, put, call } from 'redux-saga/effects';
import network from '../../../network/network';
import { workingStart, workingEnd } from '../../working/actions';
import * as actions from '../actions';
export default function _callee() {
  var _yield$take, payload, authView, url, onFailure, response;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 33;
            break;
          }

          _context.next = 3;
          return take(actions.INTERDICTION_AUTH_GET_OOW_VIEW);

        case 3:
          _yield$take = _context.sent;
          payload = _yield$take.payload;
          authView = payload.authView, url = payload.url, onFailure = payload.onFailure;
          _context.next = 8;
          return put(workingStart());

        case 8:
          _context.prev = 8;
          _context.next = 11;
          return network().post({
            url: url,
            data: {
              authType: 'OOW'
            },
            includeRootContext: true
          });

        case 11:
          response = _context.sent;

          if (!response) {
            _context.next = 20;
            break;
          }

          if (!(response.status === 'FAILURE')) {
            _context.next = 18;
            break;
          }

          _context.next = 16;
          return put(actions.setAuthFailureMessage(response));

        case 16:
          _context.next = 20;
          break;

        case 18:
          _context.next = 20;
          return put(actions.setAuthOOWView({
            authView: authView,
            oowQuestion: response.oowViewBean
          }));

        case 20:
          _context.next = 22;
          return put(workingEnd());

        case 22:
          _context.next = 31;
          break;

        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](8);
          _context.next = 28;
          return put(workingEnd());

        case 28:
          if (!onFailure) {
            _context.next = 31;
            break;
          }

          _context.next = 31;
          return call(onFailure, _context.t0);

        case 31:
          _context.next = 0;
          break;

        case 33:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[8, 24]]);
}